import { useEffect, useState } from "react";
import { t } from "../i18n";
import { X } from "lucide-react";
import { api } from "../lib/api";
import { Avatar, Flag, RedFlagIcon } from "./Avatar";

export function PersonPicker({ value, onChange, single = false }) {
  const [people, setPeople] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/people").then((r) => setPeople(r.data)).catch(() => {}); }, []);

  const selected = people.filter((p) => value.includes(p.id));
  const options = people.filter((p) => !value.includes(p.id) && (!q || p.nombre.toLowerCase().includes(q.toLowerCase()) || (p.apodo || "").toLowerCase().includes(q.toLowerCase())));

  return (
    <div data-testid="person-picker">
      <label className="label">{single ? t("person.one") : t("person.many")}</label>
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2">
          {selected.map((p) => (
            <span key={p.id} data-testid={`picked-${p.id}`} className="chip chip-on pl-1">
              <Avatar nombre={p.nombre} src={p.foto_url} size={22} redFlag={p.red_flag?.activa} /> {p.nombre} {p.red_flag?.activa && <RedFlagIcon size={12} testId={`picked-red-flag-${p.id}`} />} <Flag iso={p.pais_iso} size={14} />
              <button type="button" onClick={() => onChange(value.filter((x) => x !== p.id))} aria-label={t("common.removeItem")}><X size={12} /></button>
            </span>
          ))}
        </div>
      )}
      {(!single || selected.length === 0) && (
        <>
          <input data-testid="person-picker-search" className="field" placeholder={t("person.searchPerson")} value={q} onChange={(e) => setQ(e.target.value)} />
          {(q || selected.length === 0) && options.length > 0 && (
            <ul className="mt-2 max-h-40 overflow-y-auto surface divide-y divide-border">
              {options.slice(0, 8).map((p) => (
                <li key={p.id}>
                  <button type="button" data-testid={`person-option-${p.id}`} onClick={() => { onChange(single ? [p.id] : [...value, p.id]); setQ(""); }}
                    className="w-full flex items-center gap-3 px-3 py-2 text-sm hover:bg-secondary text-left">
                    <Avatar nombre={p.nombre} src={p.foto_url} size={28} redFlag={p.red_flag?.activa} /> <span className="flex-1 flex items-center gap-1.5">{p.nombre}{p.red_flag?.activa && <RedFlagIcon size={12} testId={`option-red-flag-${p.id}`} />}</span> <Flag iso={p.pais_iso} size={16} />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
}

export function PlaceInput({ value, onChange }) {
  const [sug, setSug] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => api.get("/places/suggest", { params: { q: value.nombre || "" } }).then((r) => setSug(r.data)).catch(() => {}), 200);
    return () => clearTimeout(t);
  }, [value.nombre, open]);

  return (
    <div data-testid="place-input">
      <label className="label">{t("person.place")}</label>
      <input data-testid="place-nombre" className="field" placeholder={t("person.placeName")} value={value.nombre || ""}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        onChange={(e) => onChange({ ...value, nombre: e.target.value })} />
      {open && sug.length > 0 && (
        <ul className="mt-1 surface divide-y divide-border max-h-36 overflow-y-auto" data-testid="place-suggestions">
          {sug.map((s, i) => (
            <li key={i}><button type="button" onMouseDown={() => onChange({ ...value, ...s })} className="w-full text-left px-3 py-2 text-sm hover:bg-secondary">
              {s.nombre} <span className="text-muted-foreground">· {[s.ciudad, s.pais].filter(Boolean).join(", ")}</span></button></li>
          ))}
        </ul>
      )}
      <div className="grid grid-cols-2 gap-2 mt-2">
        <input data-testid="place-ciudad" className="field" placeholder={t("person.city")} value={value.ciudad || ""} onChange={(e) => onChange({ ...value, ciudad: e.target.value })} />
        <input data-testid="place-pais" className="field" placeholder={t("common.country")} value={value.pais || ""} onChange={(e) => onChange({ ...value, pais: e.target.value })} />
      </div>
    </div>
  );
}
